import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import i18n from 'i18next'

import { useUser } from 'store'

interface TabConfig {
  base: string
  routes: string[]
}

interface RouteGroup {
  base: string
  tabs?: TabConfig
}

export interface RouteGroups {
  [key: string]: RouteGroup
}

export const isPathInRouteGroup = (pathname: string, routeGroup: RouteGroup) => {
  if (!routeGroup) return false
  
  if (pathname.startsWith(routeGroup.base)) {
    if (routeGroup.tabs) {
      const tabBase = routeGroup.tabs.base
      const tabRoutes = routeGroup.tabs.routes
      
      return tabRoutes.some(route => 
        pathname.startsWith(`${tabBase}/${route}`)
      )
    }
    return true
  }
  return false
}

const useLinks = ({menu}) => {
  const {t} = useTranslation()
  const location = useLocation()
  const [user] = useUser()
  const links = useMemo(() => {
    return menu
      .map(link => {
        if (!user?.admin && link.adminOnly) {
          return null
        }
        if (!user?.admin
          && link.requiredRoles
          && !link.requiredRoles.some(role => user?.roles[role])) {
          return null
        }
        return {
          label: t(link.label),
          active: location.pathname.indexOf(link.url) === 0,
          url: link.url,
          key: link.key
        }
      })
      .filter(Boolean)
  }, [menu, location, i18n.language])

  return links
}

export default useLinks